import React from "react";

// Dashboard
import Dashboard from "../dashboard/Dashboard";
import EvolutionMembres from "../pages/stats/EvolutionMembres";
// Membres
// import Membres from "../membres/Membres";
// import MembreDetails from "../membres/MembreDetails";
// import AjouterMembre from "../membres/AjouterMembre";
// import ModifierMembre from "../membres/ModifierMembre";
// import ImportMembres from "../membres/ImportMembres";

// Églises
// import Eglises from "../eglises/Eglises";
// import EgliseDetails from "../eglises/EgliseDetails";
// import AjouterEglise from "../eglises/AjouterEglise";
// import ModifierEglise from "../eglises/ModifierEglise";
// import BienvenueEglise from "../eglises/BienvenueEglise";

// Finances
// import Entrees from "../finances/Entrees";
// import Depenses from "../finances/Depenses";
// import Bilan from "../finances/Bilan";
// import NouvelleEntree from "../finances/NouvelleEntree";
// import NouvelleDepense from "../finances/NouvelleDepense";
import TypeRevenus from "../pages/finances/TypesRevenus";

import ListeDepenses from '../pages/finances/ListeDepenses';
import NouvelleDepense from '../pages/finances/NouvelleDepense';
import TypeDepenses from '../pages/finances/TypesDepenses';

// import TypeDepenses from "../finances/TypeDepenses";

// Abonnements
// import Abonnements from "../abonnements/Abonnements";
// import NouvelAbonnement from "../abonnements/NouvelAbonnement";
// import AbonnementsExpires from "../abonnements/AbonnementsExpires";

// Événements
// import Assistances from "../evenements/Assistances";
// import NouvelleAssistance from "../evenements/NouvelleAssistance";
// import Mariages from "../evenements/Mariages";
// import NouveauMariage from "../evenements/NouveauMariage";
// import Baptemes from "../evenements/Baptemes";
// import NouveauBapteme from "../evenements/NouveauBapteme";
// import Naissances from "../evenements/Naissances";
// import NouvelleNaissance from "../evenements/NouvelleNaissance";
// import Deces from "../evenements/Deces";
// import NouveauDeces from "../evenements/NouveauDeces";

// Patrimoines
// import Patrimoines from "../patrimoines/Patrimoines";
// import NouveauPatrimoine from "../patrimoines/NouveauPatrimoine";
// import ModifierPatrimoine from "../patrimoines/ModifierPatrimoine";

// Statistiques
// import Statistiques from "../stats/Statistiques";
// import StatistiquesMembres from "../stats/StatistiquesMembres";


// import StatistiquesFinances from "../stats/StatistiquesFinances";
// import StatistiquesEvenements from "../stats/StatistiquesEvenements";
import Abonnements from "../pages/abonnements/AbonnementsExpires";

// Recommandations
// import Recommandations from "../recommandations/Recommandations";
// import NouvelleRecommandation from "../recommandations/NouvelleRecommandation";

// Paramètres
// import SocieteInfos from "../parametres/SocieteInfos";
// import Utilisateurs from "../parametres/Utilisateurs";
// import UtilisateursRoles from "../parametres/UtilisateursRoles";
// import Autorisations from "../parametres/Autorisations";
// import SauvegardeManuel from "../parametres/SauvegardeManuel";
// import SauvegardeRestauration from "../parametres/SauvegardeResturation";

// Pages
// import Profile from "../pages/Profile";
// import EditProfile from "../pages/EditProfile";
// import Aide from "../pages/Aide";
// import Confidentialite from "../pages/Confidentialite";
// import Settings from "../pages/Settings";
// import Pricing from "../pages/Pricing";
// import Faq from "../pages/Faq";
// import People from "../pages/People";
// import Activity from "../pages/Activity";
// import Events from "../pages/Events";
import ListeMembres from "../pages/membres/ListeMembres";
import AjouterMembre from "../pages/membres/AjouterMembre";
import ModifierMembre from "../pages/membres/ModifierMembre";
import DetailsMembre from "../pages/membres/DetailsMembre";
import ImportExportMembres from "../pages/membres/ImportExportMembres";
// Dans votre fichier routes.js, ajoutez :



// === ÉGLISES ===
import ListeEglises from "../pages/eglises/ListeEglises";
import AjouterEglise from "../pages/eglises/AjouterEglise";
import ModifierEglise from "../pages/eglises/ModifierEglise";
import DetailsEglise from "../pages/eglises/DetailsEglise";
import DetailsTemple from '../pages/eglises/DetailsTemple';
// Dans protectedRoutes
// Dans votre fichier routes.js
import AjouterTemple from "../pages/eglises/AjouterTemple";
import ListeTemples from "../pages/eglises/ListeTemples";
// Dans protectedRoutes
// Import des composants de finances
import ListeEntrees from '../pages/finances/ListeEntrees';
import AjouterEntree from '../pages/finances/AjouterEntree';
import ModifierEntree from '../pages/finances/AjouterEntree';
// import TypesRevenus from './pages/finances/TypesRevenus';


import ListeAbonnements from '../pages/abonnements/ListeAbonnements';
import NouvelAbonnement from '../pages/abonnements/NouvelAbonnement';
import AbonnementsExpire from '../pages/abonnements/AbonnementsExpire';



// Événements - Assistances
import ListeAssistances from "../pages/evenements/assistances/ListeAssistances";
import NouvelleAssistance from "../pages/evenements/assistances/NouvelleAssistance";

// Événements - Mariages
import ListeMariages from "../pages/evenements/mariages/ListeMariages";
import NouveauMariage from "../pages/evenements/mariages/NouveauMariage";

// Événements - Baptêmes
import ListeBaptemes from "../pages/evenements/baptemes/ListeBaptemes";
import NouveauBapteme from "../pages/evenements/baptemes/NouveauBapteme";

// Événements - Naissances
import ListeNaissances from "../pages/evenements/naissances/ListeNaissances";
import NouvelleNaissance from "../pages/evenements/naissances/NouvelleNaissance";

// Événements - Décès
import ListeDeces from "../pages/evenements/deces/ListeDeces";
import NouveauDeces from "../pages/evenements/deces/NouveauDeces";


// Imports
import StatsDashboard from '../pages/statistiques/StatsDashboard';
import StatsMembres from '../pages/statistiques/StatsMembres';
import StatsFinances from '../pages/statistiques/StatsFinances';
import StatsEvenements from '../pages/statistiques/StatsEvenements';

// Dans le tableau protectedRoutes
// Imports
import StatsAbonnements from '../pages/statistiques/StatsAbonnements';

// Dans le tableau protectedRoutes
// Imports
import ListeRecommandations from '../pages/recommandations/ListeRecommandations';
import NouvelleRecommandation from '../pages/recommandations/NouvelleRecommandation';

// Dans le tableau protectedRoutes
// Imports
import DetailsRecommandation from '../pages/recommandations/DetailsRecommandation';

// Dans le tableau protectedRoutes
// Imports
import SauvegardeManuelle from '../pages/sauvegarde/SauvegardeManuelle';
import Restauration from '../pages/sauvegarde/Restauration';

// Dans le tableau protectedRoutes

import ViewFidele from '../pages/fidele/ViewFidele';
import EditFidele from '../pages/fidele/EditFidele';
import Aide from '../pages/Aide';
import Parametres from '../pages/parametres/Parametres';
import Logout from '../pages/Logout';

import Accueil from '../pages/Accueil';

import ListePatrimoines from '../pages/patrimoines/ListePatrimoines';
import AjouterPatrimoine from '../pages/patrimoines/AjouterPatrimoine';
const protectedRoutes = [




{ path: "/patrimoines/liste", element: <ListePatrimoines /> },
{ path: "/patrimoinesAjouter", element: <AjouterPatrimoine /> },
{ path: "/patrimoines/modifier/:id", element: <AjouterPatrimoine /> },


{ path: "accueil", element: <Accueil /> },
{ path: "fidele/:matricule?", element: <ViewFidele /> },

{ path: "profil/modifier/:id", element: <EditFidele /> },






{ path: "aide", element: <Aide /> },

{ path: "aide/:guide", element: <Aide /> },

{ path: "parametres", element: <Parametres /> },

{ path: "parametres/*", element: <Parametres /> },

{ path: "logout", element: <Logout /> },


{ path: "parametres/sauvegarde/manuel", element: <SauvegardeManuelle /> },
{ path: "parametres/sauvegarde/restauration", element: <Restauration /> },

{ path: "recommandations/details/:id", element: <DetailsRecommandation /> },
  { path: "recommandations/liste", element: <ListeRecommandations /> },
{ path: "recommandations/nouveau", element: <NouvelleRecommandation /> },
{ path: "recommandations/modifier/:id", element: <NouvelleRecommandation /> },
  { path: "stats/abonnements", element: <StatsAbonnements /> },
{ path: "stats/dashboard", element: <StatsDashboard /> },
{ path: "stats/membres", element: <StatsMembres /> },
{ path: "stats/finances", element: <StatsFinances /> },
{ path: "stats/evenements", element: <StatsEvenements /> },
  // === ÉVÉNEMENTS - ASSISTANCES ===
{ path: "evenements/assistances", element: <ListeAssistances /> },
{ path: "evenements/assistances/nouveau", element: <NouvelleAssistance /> },
{ path: "evenements/assistances/modifier/:id", element: <NouvelleAssistance /> },

// === ÉVÉNEMENTS - MARIAGES ===
{ path: "evenements/mariages", element: <ListeMariages /> },
{ path: "evenements/mariagesNouveau", element: <NouveauMariage /> },
{ path: "evenements/mariages/modifier/:id", element: <NouveauMariage /> },

// === ÉVÉNEMENTS - BAPTÊMES ===
{ path: "evenements/baptemes", element: <ListeBaptemes /> },
{ path: "evenements/baptemesNouveau", element: <NouveauBapteme /> },
{ path: "evenements/baptemes/modifier/:id", element: <NouveauBapteme /> },

// === ÉVÉNEMENTS - NAISSANCES ===
{ path: "evenements/naissances", element: <ListeNaissances /> },
{ path: "evenements/naissancesNouveau", element: <NouvelleNaissance /> },
{ path: "evenements/naissances/modifier/:id", element: <NouvelleNaissance /> },

// === ÉVÉNEMENTS - DÉCÈS ===
{ path: "evenements/deces", element: <ListeDeces /> },
{ path: "evenements/decesNouveau", element: <NouveauDeces /> },
{ path: "evenements/deces/modifier/:id", element: <NouveauDeces /> },
{ path: "finances/entrees/modifier/:id", element: <ModifierEntree /> },
// { path: "finances/types/revenus", element: <TypesRevenus /> },


{ path: "abonnements/liste", element: <ListeAbonnements /> },
{ path: "abonnementsNouveau", element: <NouvelAbonnement /> },
{ path: "abonnementsExpire", element: <AbonnementsExpire /> },

{ path: "abonnements/modifier/:id", element: <NouvelAbonnement /> },
{ path: "abonnements/renouveler/:id", element: <NouvelAbonnement /> },



{ path: "finances/entreesNouveau", element: <AjouterEntree /> },
  { path: "finances/entrees", element: <ListeEntrees /> },
  // === DASHBOARD ===
  { path: "dashboard", element: <Dashboard /> },
{ path: "eglises/ajouter-temple", element: <AjouterTemple /> },
{ path: "eglises/liste", element: <ListeEglises /> },
{ path: "eglises/ajouter", element: <AjouterEglise /> },
{ path: "eglises/modifier/:id", element: <ModifierEglise /> },
{ path: "eglises/:id", element: <DetailsEglise /> },
{ path: "temples/liste", element: <ListeTemples /> },
{ path: "eglises/sieges", element: <ListeEglises /> },

{ path: "eglises/:id", element: <DetailsEglise /> },

{ path: "temples/:id", element: <DetailsTemple /> },
// Filtres

  { path: "membres/liste", element: <ListeMembres /> },
  { path: "membres/ajouter", element: <AjouterMembre /> },
  { path: "membres/modifier/:id", element: <ModifierMembre /> },
  { path: "membres/import", element: <ImportExportMembres /> },
  { path: "membres/:id", element: <DetailsMembre /> },
  
  // Filtres par rôle
  { path: "membres/role/pasteurs", element: <ListeMembres filtre="Pasteur" /> },
  { path: "membres/role/diaconesse", element: <ListeMembres filtre="Diaconesse" /> },
   { path: "membres/role/dp", element: <ListeMembres filtre="Dp" /> },
  { path: "membres/role/anciens", element: <ListeMembres filtre="Ancien" /> },
  { path: "membres/role/diacres", element: <ListeMembres filtre="Diacre" /> },
  { path: "membres/role/diaconesses", element: <ListeMembres filtre="Diaconesse" /> },
  { path: "membres/role/jeunes", element: <ListeMembres filtre="Jeune" /> },
  { path: "membres/role/nouveaux", element: <ListeMembres filtre="Nouveau" /> },
  
  // Filtres par genre
  { path: "membres/genre/hommes", element: <ListeMembres genre="Homme" /> },
  { path: "membres/genre/femmes", element: <ListeMembres genre="Femme" /> },
  { path: "membres/genre/enfants", element: <ListeMembres genre="Enfant" /> },
  // { path: "dashboard/finance", element: <Dashboard /> },
  // { path: "dashboard/membres", element: <Dashboard /> },
  // { path: "dashboard/evenements", element: <Dashboard /> },

  // === MEMBRES ===
  // { path: "membres/liste", element: <Membres /> },
  // { path: "membres/ajouter", element: <AjouterMembre /> },
  // { path: "membres/modifier/:id", element: <ModifierMembre /> },
  // { path: "membres/import", element: <ImportMembres /> },
  // { path: "membres/:id", element: <MembreDetails /> },
  // { path: "membres/role/pasteurs", element: <Membres filtre="Pasteur" /> },
  // { path: "membres/role/anciens", element: <Membres filtre="Ancien" /> },
  // { path: "membres/role/diacres", element: <Membres filtre="Diacre" /> },
  // { path: "membres/role/jeunes", element: <Membres filtre="Jeune" /> },
  // { path: "membres/role/nouveaux", element: <Membres filtre="Nouveau" /> },

  // === ÉGLISES ===
  // { path: "eglises/liste", element: <Eglises /> },
  // { path: "eglises/ajouter", element: <AjouterEglise /> },
  // { path: "eglises/modifier/:id", element: <ModifierEglise /> },
  // { path: "eglises/:id", element: <EgliseDetails /> },
  // { path: "eglises/bienvenue/:id", element: <BienvenueEglise /> },

  // === FINANCES ===
  // Entrées
  // { path: "finances/entrees", element: <Entrees /> },
  // { path: "finances/entrees/nouveau", element: <NouvelleEntree /> },
  // { path: "finances/entrees/modifier/:id", element: <NouvelleEntree /> },
  
  // Dépenses
  { path: "finances/depenses", element: <ListeDepenses /> },
  { path: "finances/depensesNouveau", element: <NouvelleDepense /> },
  { path: "finances/depenses/modifier/:id", element: <NouvelleDepense /> },
  
  // Bilan
  // { path: "finances/bilan", element: <Bilan /> },
  // { path: "finances/bilan/mensuel", element: <Bilan periode="mensuel" /> },
  // { path: "finances/bilan/annuel", element: <Bilan periode="annuel" /> },
  
  // Types
  { path: "finances/typesRevenus", element: <TypeRevenus /> },
  { path: "finances/typesDepenses", element: <TypeDepenses /> },

  // === ABONNEMENTS ===
  // { path: "abonnements/liste", element: <Abonnements /> },
  // { path: "abonnements/nouveau", element: <NouvelAbonnement /> },
  // { path: "abonnements/expires", element: <AbonnementsExpires /> },
  // { path: "abonnements/modifier/:id", element: <NouvelAbonnement /> },

  // === ÉVÉNEMENTS ===
  // Assistances
  // { path: "evenements/assistances", element: <Assistances /> },
  // { path: "evenements/assistances/nouveau", element: <NouvelleAssistance /> },
  // { path: "evenements/assistances/modifier/:id", element: <NouvelleAssistance /> },
  
  // Mariages
  // { path: "evenements/mariages", element: <Mariages /> },
  // { path: "evenements/mariages/nouveau", element: <NouveauMariage /> },
  // { path: "evenements/mariages/modifier/:id", element: <NouveauMariage /> },
  
  // Baptêmes
  // { path: "evenements/baptemes", element: <Baptemes /> },
  // { path: "evenements/baptemes/nouveau", element: <NouveauBapteme /> },
  // { path: "evenements/baptemes/modifier/:id", element: <NouveauBapteme /> },
  
  // Naissances
  // { path: "evenements/naissances", element: <Naissances /> },
  // { path: "evenements/naissances/nouveau", element: <NouvelleNaissance /> },
  // { path: "evenements/naissances/modifier/:id", element: <NouvelleNaissance /> },
  
  // Décès
  // { path: "evenements/deces", element: <Deces /> },
  // { path: "evenements/deces/nouveau", element: <NouveauDeces /> },
  // { path: "evenements/deces/modifier/:id", element: <NouveauDeces /> },

  // === PATRIMOINES ===
  // { path: "patrimoines/liste", element: <Patrimoines /> },
  // { path: "patrimoines/nouveau", element: <NouveauPatrimoine /> },
  // { path: "patrimoines/modifier/:id", element: <ModifierPatrimoine /> },

  // === STATISTIQUES ===
  // { path: "stats/dashboard", element: <Statistiques /> },
  // { path: "stats/membres", element: <StatistiquesMembres /> },
  { path: "stats/membresEvolution", element: <EvolutionMembres type="evolution" /> },
  // { path: "stats/membres/repartition", element: <StatistiquesMembres type="repartition" /> },
  // { path: "stats/finances", element: <StatistiquesFinances /> },
  // { path: "stats/finances/entrees", element: <StatistiquesFinances type="entrees" /> },
  // { path: "stats/finances/depenses", element: <StatistiquesFinances type="depenses" /> },
  // { path: "stats/finances/comparatif", element: <StatistiquesFinances type="comparatif" /> },
  // { path: "stats/evenements", element: <StatistiquesEvenements /> },
  { path: "abonnements/expires", element: <Abonnements /> },

  // === RECOMMANDATIONS ===
  // { path: "recommandations/liste", element: <Recommandations /> },
  // { path: "recommandations/nouveau", element: <NouvelleRecommandation /> },
  // { path: "recommandations/modifier/:id", element: <NouvelleRecommandation /> },

  // === PARAMÈTRES ===
  // { path: "parametres/societe", element: <SocieteInfos /> },
  // { path: "parametres/utilisateurs", element: <Utilisateurs /> },
  // { path: "parametres/utilisateurs/roles", element: <UtilisateursRoles /> },
  // { path: "parametres/autorisations", element: <Autorisations /> },
  // { path: "parametres/sauvegarde/manuel", element: <SauvegardeManuel /> },
  // { path: "parametres/sauvegarde/restauration", element: <SauvegardeRestauration /> },

  // === PAGES ===
  // { path: "pages/profile", element: <Profile /> },
  // { path: "pages/edit-profile", element: <EditProfile /> },
  // { path: "pages/settings", element: <Settings /> },
  // { path: "pages/aide", element: <Aide /> },
  // { path: "pages/confidentialite", element: <Confidentialite /> },
  // { path: "pages/pricing", element: <Pricing /> },
  // { path: "pages/faq", element: <Faq /> },
  // { path: "pages/people", element: <People /> },
  // { path: "pages/activity", element: <Activity /> },
  // { path: "pages/events", element: <Events /> }
];

export default protectedRoutes;